import { Box, Grid, IconButton, Paper, Typography, useMediaQuery } from '@mui/material';
import { useLocation, useNavigate } from 'react-router-dom';
import WinnersNavbar from '../../features/RnR/RnRWinners/components/WinnersNavbar';
import GiftNavbar from '../../features/Gift/components/common/GiftNavbar';
import ShabashNavbar from '../../features/Shabash/components/ShabashNavbar';
import AnnouncementNavbar from '../../features/Announcement/components/AnnouncementNavbar';
import ProfileNavbar from '../../features/Profile/components/ProfileNavbar';
import { variants } from '../../variants/variants';
import HomeNavbar from '../../features/Home/components/HomeNavbar';
import DelightsNavbar from '../../features/Delight/components/DelightsNavbar';
import GGBotNavbar from '../../features/GGBot/GGBotNavbar';
import FeedbackNavbar from '../../features/Feedback/components/FeedbackNavbar';
import { ArrowBackIosNewRounded, KeyboardBackspace } from '@mui/icons-material';
import { useTheme } from '@emotion/react';
import PublicNavbar from '../../features/Gnn/components/PublicPage/PublicNavbar';
const navigations = {
  rnr: <WinnersNavbar />,
  home: <HomeNavbar />,
  delights: <DelightsNavbar />,
  gift: <GiftNavbar />,
  shabash: <ShabashNavbar />,
  announcement: <AnnouncementNavbar />,
  profile: <ProfileNavbar />,
  chats: <ProfileNavbar />,
  aboutme: <ProfileNavbar />,
  gbot: <GGBotNavbar />,
  feedback: <FeedbackNavbar />,
  Public: <PublicNavbar />,
};


function NavBar () {
  const { pathname } = useLocation();
  const theme = useTheme();
  const navigate = useNavigate();
  const page = pathname.split('/')[2];
  const pageSelected = pathname.split('/')[3];
  console.log(page, pageSelected, 'LOCATION');
  const isMobile = useMediaQuery(theme.breakpoints.down('lg'));
  const handleNavigateBack = () => {
    navigate('/home');
  };
  if (page == 'linkway') return null;
  return (
    <Grid item xs={12} sx={{ height: '62px'}}>
      {/* <Box
        component={Paper}
        elevation={0}
        sx={{
          p: 1,
          border:isMobile?0:1,
          borderBottom: isMobile&&1,
          borderColor: 'divider',
          background: variants.boxBackground.NAVBAR,
          borderRadius: isMobile?0:variants.boxRadius.NAVBAR,
          display: 'flex',
        }}
      > */}
        {/* <IconButton
          id='backToHome'
          onClick={handleNavigateBack}
          sx={{
            p: 0,
            pr: 1,
            display: 'none',
            [theme.breakpoints.down('lg')]: {
              display: 'flex',
            },
          }}
        >
          <ArrowBackIosNewRounded fontSize='small' />
        </IconButton> */}
        {navigations[page]}
      {/* </Box> */}
    </Grid>
  );
}

export default NavBar;
